

// TODO migrate to DOM7 -> https://framework7.io/docs/dom7.html
import * as $ from 'jquery';
Object.assign(global, { $, jQuery: $ });
